import Button from "components/atoms/Button";
import Icon from "components/atoms/Icon";
import Carousel from "components/molecules/Carousel";
import Modal from 'components/organisms/Modal';
import ModalView3D from "components/organisms/ModalView3D";
import { SpinLoading } from 'constants/styledComponent';
import FsLightbox from "fslightbox-react";
import useWindowSize from 'hooks/useWindowSize';
import React, { memo, ReactNode, useEffect, useMemo, useRef, useState } from "react";
import Swiper, { SwiperOptions } from "swiper";
import { SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import { Placeholder, PlayButton } from "../player/styled";
import "./index.scss";
import ProductPreview from "./ProductPreview";

interface ProductcarouselProps {
  data: {
    key: number;
    src: string;
    type: string;
  }[];
  tag?: ReactNode;
  onCompare?: () => void;
  toggleCompare: any;
  topTrademarks?: string[];
  bottomTrademarks?: string[];
  product: any;
  iframe?: string;
  plattar_url?: string;
}

interface ProductItemProps {
  src: string;
  name: string;
  shouldLazy?: boolean;
  isVideo?: boolean;
}

const ProductThumb: React.FC<ProductItemProps> = memo(
  ({ src, name, isVideo }) => {
    return (
      <div className="m-productcarousel_item">
        {isVideo && (
          <Placeholder className="m-player-placeholder">
            <PlayButton className="m-player-playbtn" />
          </Placeholder>
        )}
        <img src={src} alt={name} />
      </div>
    );
  },
);

const Productcarousel: React.FC<ProductcarouselProps> = ({
  data,
  tag,
  // topTrademarks,
  // bottomTrademarks,
  product: { name },
  toggleCompare,
  onCompare,
  iframe,
  plattar_url
}) => {
  const { width } = useWindowSize();
  const [lightboxToggler, setLightboxToggler] = useState<{
    toggler: boolean;
    activeSlide: number;
    isShowTradeMarks?: boolean;
  }>({
    toggler: false,
    activeSlide: 1,
    isShowTradeMarks: true,
  });
  // const [isShowTradeMarks, setIsShowTradeMarks] = useState(true);
  const [isOpenModalView3D, setIsOpenModalView3D] = useState(false);
  const plattarLibFetched = useRef<boolean>(false);
  const [isLoadingMobileAR, setLoadingMobileAR] = useState<boolean>(false);
  const [isOpen3DModal, setIsOpen3DModal] = useState<boolean>(false);
  const [plattarScene3DId, setPlattarScene3DId] = useState<string>('');
  const [activeIndexSliderThumbWrap, setActiveIndexSliderThumbWrap] = useState(0);
  useEffect(() => {
    const initialGalleryThumbs = new Swiper(
      ".m-productcarousel .m-productcarousel_thumbs",
      {
        preloadImages: true,
        lazy: true,
        direction: "horizontal",
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        navigation: {
          nextEl: `.m-productcarousel .swiper-button.swiper-button-next ${data.length < 2 ? ".d-none" : ""
            }`,
          prevEl: `.m-productcarousel .swiper-button.swiper-button-prev ${data.length < 2 ? ".d-none" : ""
            }`,
        },
        autoplay: false,
      },
    );

    const initialSwiperOption: SwiperOptions = {
      preloadImages: true,
      lazy: true,
      loop: false,
      allowTouchMove: false,
      thumbs: {
        swiper: initialGalleryThumbs,
      },
    };

    const initialSwiper = new Swiper(
      ".m-productcarousel .m-productcarousel_preview",
      initialSwiperOption,
    );

  }, [data]);

  const types = data && data.map(item => item.type);
  const lightBoxData = data && data.map(item => item.src);
  const lightBoxPreview = data && data.map(item => item.preview || item.src);

  // const trademarks = useMemo(() => {
  //   return (
  //     <div className="m-productcarousel_preview_trademark">
  //       <div className="m-productcarousel_preview_trademark_top-bottom">
  //         {topTrademarks &&
  //           topTrademarks.length > 0 &&
  //           topTrademarks.map((img, index2) => (
  //             <div
  //               key={index2}
  //               className="m-productcarousel_preview_trademark_top-bottom_item"
  //             >
  //               <Image src={`${BASE_URL}${img}`} alt={`Trademark ${name}`} />
  //             </div>
  //           ))}
  //       </div>
  //       <div className="m-productcarousel_preview_trademark_top-bottom">
  //         {bottomTrademarks &&
  //           bottomTrademarks.length > 0 &&
  //           bottomTrademarks.map((img, index3) => (
  //             <div
  //               key={index3}
  //               className="m-productcarousel_preview_trademark_top-bottom_item"
  //             >
  //               <Image src={`${BASE_URL}${img}`} alt={name} />
  //             </div>
  //           ))}
  //       </div>
  //     </div>
  //   );
  // }, [bottomTrademarks, name, topTrademarks]);
  async function launchAR() {
    const embed = document.getElementById('plattar-embed') as any;
    if (embed) {
      try {
        setLoadingMobileAR(true);
        await embed?.startAR();
      }
      catch (err) {
        console.error(err);
      }
      finally {
        setLoadingMobileAR(false);
      }
    }
  }

  const onOpen3DModal = async (newPattarSceneId: string | undefined) => {
    if (!plattarLibFetched.current) {
      plattarLibFetched.current = true;
      require('@plattar/plattar-ar-adapter');
      require('@plattar/plattar-qrcode');
    }
    if (width <= 1024) {
      launchAR();
      return;
    }
    let finalPlattarSceneId = newPattarSceneId;
    setIsOpen3DModal(true);
    if (finalPlattarSceneId) {
      setPlattarScene3DId(finalPlattarSceneId);
    }
  };

  const sceneId = useMemo(() => {
    const urlParams = new URLSearchParams(plattar_url?.split('?')[1]);
    const plattarSceneId = urlParams.get('scene-id') || urlParams.get('scene_id');
    return plattarSceneId;
  }, [plattar_url]);

  return (
    <div className="m-productcarousel" style={{ overflow: "hidden" }}>
      {isLoadingMobileAR && <SpinLoading />}
      <div className="m-productcarousel_preview">
        <div className="m-productcarousel-swiper swiper-wrapper">
          <Carousel
            slidesPerView={1}
            rebuildOnUpdate
            autoHeight={false}
            onTransitionEnd={(sw) => setActiveIndexSliderThumbWrap(sw?.activeIndex || 0)}
            activeIndex={activeIndexSliderThumbWrap}
            isThumbnail
          >
            {lightBoxPreview &&
              lightBoxPreview.map((item, index) => (
                <SwiperSlide key={`m-productcarousel-image-slide-preview-${index.toString()}`}>
                  <div
                    onClick={() => {
                      setLightboxToggler({
                        toggler: !lightboxToggler.toggler,
                        activeSlide: index + 1,
                      });
                    }}
                  >
                    <ProductPreview
                      src={item}
                      name={name}
                      shouldLazy={false}
                      isVideo={lightBoxData[index].includes("youtube.com")}
                    />
                  </div>
                </SwiperSlide>
              ))}
          </Carousel>
        </div>
        {/* {(isShowTradeMarks && activeIndexSliderThumbWrap === 0) && trademarks} */}
        <div className="m-productcarousel_tag">{tag}</div>
        <div className="m-productcarousel_comparebutton">
          {toggleCompare === null
            ? ""
            : onCompare &&
            (toggleCompare ? (
              <Button
                variant={"dark"}
                modifiers={["xsmall", "rounded"]}
                onClick={e => onCompare(e)}
              >
                So sánh
              </Button>
            ) : (
              <Button
                variant="dark"
                modifiers={["xsmall", "rounded", "black"]}
                onClick={e => onCompare(e)}
              >
                So sánh
              </Button>
            ))}
        </div>
      </div>
      {
        (iframe || plattar_url) && (
          <div className="m-productcarousel_buttons">
            {
              iframe && (
                <div
                  className="m-productcarousel_view3D"
                >
                  <div className="m-productcarousel_view3D_panel">
                    <div className="m-productcarousel_view3D_panel_btnseries" onClick={() => setIsOpenModalView3D(true)}>
                      <span className="m-productcarousel_view3D_panel_btnseries_icon">
                        <span className="m-productcarousel_view3D_panel_btnseries_iconText">3D view</span>
                        <Icon iconName="icon-360" />
                      </span>
                      <span className="m-productcarousel_view3D_panel_btnseries_text">Xem ảnh 3D</span>
                    </div>
                  </div>
                </div>
              )
            }
            {
              plattar_url && (
                <div
                  className="m-productcarousel_view3D"
                >
                  <div className="m-productcarousel_view3D_panel">
                    <div className="m-productcarousel_view3D_panel_btnseries" onClick={() => onOpen3DModal(plattar_url)}>
                      <span className="m-productcarousel_view3D_panel_btnseries_icon">
                        <Icon iconName="ar" />
                      </span>
                      <span className="m-productcarousel_view3D_panel_btnseries_text">Xem AR</span>
                    </div>
                  </div>
                </div>
              )
            }
          </div>
        )
      }
      <div className="m-productcarousel_sliders">
        <div className="m-productcarousel_thumbs-wrap">
          <Carousel
            slidesPerView={3}
            rebuildOnUpdate
            autoHeight={false}
            spaceBetween={7}
            isThumbnail
          >
            {data &&
              data.map((item, idx) => (
                <SwiperSlide key={`m-productcarousel-image-slide-${idx.toString()}`}>
                  <div
                    className="swiper-slide"
                    onClick={() => {
                      // setIsShowTradeMarks(item.key === 0);
                      setActiveIndexSliderThumbWrap(idx);
                    }}
                  >
                    <ProductThumb
                      src={item.thumb}
                      name={name}
                      isVideo={lightBoxData[idx].includes("youtube.com")}
                    />
                  </div>
                </SwiperSlide>
              ))}
          </Carousel>
        </div>
      </div>

      <FsLightbox
        toggler={lightboxToggler.toggler}
        sources={lightBoxData}
        slide={lightboxToggler.activeSlide}
        types={types}
      />

      {
        iframe && (
          <ModalView3D
            isOpen={isOpenModalView3D}
            onCloseRequest={() => setIsOpenModalView3D(false)}
            iframe={iframe}
            noPadding
          />
        )
      }
      {
        width <= 1024 && (
          <div style={{ display: 'none' }}>
            {/* @ts-ignore */}
            <plattar-embed id="plattar-embed" scene-id={sceneId} qr-type="ar" width="100%" height="100%"><plattar-qrcode url={plattarScene3DId} width="280px" height="280px" margin="12" qr-type="default" color="#101721" shorten="true"></plattar-qrcode></plattar-embed>
          </div>
        )
      }
      <Modal noPadding portalClassName="m-productcarousel_arModal" isOpen={isOpen3DModal} onCloseRequest={() => setIsOpen3DModal(false)} fullWidthContent className="m-productcarousel_modal" >
        <div className="o-modal_content_icon" onClick={() => setIsOpen3DModal(false)}>
          <Icon
            iconName="x"
            size="close-smaller"
          />
        </div>
        <div className="m-productcarousel_modalbodywrapper">
          {/* @ts-ignore */}
          <plattar-embed id="plattar-embed" scene-id={sceneId} qr-type="ar" width="100%" height="100%"><plattar-qrcode url={plattarScene3DId} width="280px" height="280px" margin="12" qr-type="default" color="#101721" shorten="true"></plattar-qrcode></plattar-embed>
          <div className="m-productcarousel_note">
            QUÉT QR BẰNG ĐIỆN THOẠI CỦA BẠN
            <br />
            XEM SẢN PHẨM THEO CÁCH CỦA BẠN
          </div>
        </div>
      </Modal>
    </div >
  );
};

Productcarousel.defaultProps = {};

export default Productcarousel;
